import { useEffect, useState } from "react";
import type { Scope } from "./db";
import { photoBlob } from "./photoStore";

/** The local copy of a photo that waits on the phone, or a link to save it. Nothing when the bytes are gone. */
export function PhotoThumb({ scope, id, alt, copy = false }: { scope: Scope; id: string; alt: string; copy?: boolean }) {
  const [shown, setShown] = useState<{ url: string; ext: string } | null>(null);
  useEffect(() => {
    let live = true;
    let made: string | null = null;
    void photoBlob(scope, id).then((blob) => {
      if (!live || !blob) return;
      made = URL.createObjectURL(blob);
      setShown({ url: made, ext: blob.type === "image/jpeg" ? "jpg" : blob.type.split("/")[1] || "jpg" });
    });
    return () => {
      live = false;
      if (made) URL.revokeObjectURL(made);
    };
  }, [scope, id]);
  if (!shown) return null;
  if (copy) {
    return (
      <a href={shown.url} download={`photo-${id}.${shown.ext}`} data-testid="photo-copy">
        Save a copy
      </a>
    );
  }
  return <img className="photo-thumb" src={shown.url} alt={alt} data-testid="photo-thumb" />;
}
